// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___RGh4b","font_button_m":"font_button_m___bKini","font_button_s":"font_button_s___Kbj8r","global":"global___FWuDP","container":"container___UevYl"};